import React, { useMemo, useState } from "react";
import { UserPlus, Check, X } from "lucide-react";
import { distanceTier, TIER_LABEL } from "./cellHelpers";

export const AssignControl = ({ row, groups, onAssign }) => {
  const options = useMemo(() => groups
    .map((g) => ({ g, tier: distanceTier(row.detected_postcode || row.postcode, g.host_postcode), spaces: (g.capacity || 15) - (g.members || []).length }))
    .filter((o) => o.spaces > 0)
    .sort((a, b) => a.tier - b.tier || b.spaces - a.spaces), [groups, row]);
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState("");
  const id = row.record_id;

  if (!options.length) return <span className="text-xs" style={{ color: "var(--sj-text-3)" }}>No group has space</span>;
  const nearest = options[0];
  if (!open) {
    return (
      <button data-testid={`cell-assign-open-${id}`} onClick={() => { setSel(nearest.g.group_id); setOpen(true); }}
        className="inline-flex items-center gap-1 rounded-lg border px-2.5 py-1 text-xs font-medium whitespace-nowrap" style={{ borderColor: "var(--sj-primary)", color: "var(--sj-primary)" }}>
        <UserPlus className="h-3.5 w-3.5" /> Assign · {nearest.g.group_name}
      </button>
    );
  }
  return (
    <span className="flex items-center gap-1">
      <select data-testid={`cell-assign-select-${id}`} value={sel} onChange={(e) => setSel(e.target.value)} className="bg-[#EDF2F4] border border-[#EBE9E4] rounded-lg outline-none px-2 py-1 text-xs max-w-[240px]">
        {options.map((o, i) => (
          <option key={o.g.group_id} value={o.g.group_id}>{i === 0 ? "★ " : ""}{o.g.group_name} — {TIER_LABEL[o.tier]} · {o.spaces} space{o.spaces === 1 ? "" : "s"}{o.g.status === "Approved" ? " · approved" : ""}</option>
        ))}
      </select>
      <button data-testid={`cell-assign-confirm-${id}`} onClick={() => onAssign(row, sel).then((ok) => ok && setOpen(false))} className="rounded p-1.5 text-white" style={{ background: "var(--sj-primary)" }}><Check className="h-3.5 w-3.5" /></button>
      <button data-testid={`cell-assign-cancel-${id}`} onClick={() => setOpen(false)} className="rounded p-1.5" style={{ color: "var(--sj-text-3)" }}><X className="h-3.5 w-3.5" /></button>
    </span>
  );
};
